import { useEffect, useState } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestQuery, { UseRestQueryResponse } from "@/remoteState/useRestQuery";
import { TermsOfService } from "@/types/models/TermsOfService.interface";

const FORMATIVE_TOS_SLUG = "formative-tos";

interface UseFormativeTOSProps {
  userId: string;
}

const useFormativeTOS = ({ userId }: UseFormativeTOSProps) => {
  const [shouldDisplayFormativeTOS, setShouldDisplayFormativeTOS] =
    useState(false);

  const latestFormativeTOSUrlResource = `${API_BASE_URL}/api/v3/terms-of-service/${FORMATIVE_TOS_SLUG}/version/latest/`;
  const { data: latestFormativeTOS }: UseRestQueryResponse<TermsOfService> =
    useRestQuery(latestFormativeTOSUrlResource);
  const currentTOSVersion = latestFormativeTOS?.version;
  const formativeTOSText = latestFormativeTOS?.text;

  const latestTOSForCurrentUserResource = currentTOSVersion
    ? `${API_BASE_URL}/api/v3/user/${userId}/terms-of-service/${FORMATIVE_TOS_SLUG}/version/${currentTOSVersion}/`
    : "";
  const latestTOSForCurrentUser: UseRestQueryResponse<TermsOfService> =
    useRestQuery(latestTOSForCurrentUserResource, { skip: !currentTOSVersion });

  useEffect(() => {
    if (latestTOSForCurrentUser?.error) {
      setShouldDisplayFormativeTOS(true);
    }
  }, [latestTOSForCurrentUser]);

  return {
    currentTOSVersion,
    formativeTOSText,
    shouldDisplayFormativeTOS,
    setShouldDisplayFormativeTOS,
  };
};

export default useFormativeTOS;
